import React from 'react';

const Faq = () => {
    return (
        <div>
            <h2>Why FAQ Pages Are A Priority</h2>
            <p>FAQ pages continue to be a priority area for SEO and digital marketing professionals.</p>
            <p>An FAQ page is one of the simplest ways to improve your site and help site visitors and users.</p>
            <p>Your FAQ section should be seen as a constantly expanding source of value provided to your audience. It is a place where their ever-changing and growing requirements are not only met but anticipated and exceeded frequently.</p>
            <p>In no small part, the importance of FAQ pages has been driven in recent years by the growth in voice search, mobile search, and personal/home assistants and speakers.</p>
        </div>
    );
};

export default Faq;